import { Stepper as StepperBase } from './Stepper';
import { StepperCss as EmoStepper } from './style';

const styledComponents = {
  StepperComp: EmoStepper
};

export const StepperStyled = props => <StepperBase components={styledComponents} {...props} />;

StepperStyled.displayName = 'StepperStyled';
